module.exports = __webpack_public_path__ + "img/logo.9c91bba5.jpg";